import { FC, useMemo } from "react";
import { useRecoilValue } from "recoil";

import { useCrudEditContext } from "@ryde/redux";
import {
  apiDataFetchingAtom,
  editFormDataAF,
  EditFormMode,
  getCourseRoutesInfo,
  ICourseDto,
  MapRouteBlockTypeEnum,
} from "@ryde/shared";

import { RouteBlock } from "../../../map";
import { CourseWaypointMapControlsHost } from "../../station-routes";
import { CourseMapStyled, CourseMapWrapperStyled } from "./course.styled";

interface ICourseMap {
  mode?: EditFormMode | undefined;
}

export const CourseMap: FC<ICourseMap> = ({ mode }) => {
  const { entity } = useCrudEditContext<ICourseDto>();
  const courseDto = useRecoilValue<Partial<ICourseDto> | undefined>(
    editFormDataAF([entity, mode || EditFormMode.CrudRoute]),
  );

  const routes = useMemo(() => getCourseRoutesInfo(courseDto), [courseDto]);

  const dataLoading = useRecoilValue(apiDataFetchingAtom);

  const mapHiddenStateCondition = useMemo(() => {
    return Boolean(dataLoading);
  }, [dataLoading]);

  return (
    <CourseMapWrapperStyled className="CourseDrawer-Map">
      <CourseMapStyled>
        <RouteBlock
          hiddenMapState={mapHiddenStateCondition}
          routes={routes}
          routeBlockType={MapRouteBlockTypeEnum.Courses}
          mapExtraLayers={<CourseWaypointMapControlsHost />}
        />
      </CourseMapStyled>
    </CourseMapWrapperStyled>
  );
};
